import React, { useCallback, useContext, useEffect, useState } from 'react';
import ModalComponentNoButton from './ModalComponentNoButton';
import { Form } from 'react-bootstrap';
import AddressInputs from './AddressInputs';
import { bool, func, object } from 'prop-types';
import { ToastContext } from './context/ToastContext';

export default function AccountEditAddressModal({ show, setShow = () => {}, mailingAddress, onUpdate = () => { } }) {
    const [mailingAddressInputs, setMailingAddressInputs] = useState({});
    const [initialInputs, setInitialInputs] = useState({});
    const { sendMessage } = useContext(ToastContext);
    const editMailingAddress = useCallback(async () => {
        try {
            if (!mailingAddress.id) {
                return;
            }
            const validatedInputs = { ...mailingAddressInputs };
            for (const key of Object.keys(validatedInputs)) {
                if (validatedInputs[key] === '') {
                    delete validatedInputs[key];
                }
            }
            const response = await fetch(process.env.APP_URL + `api/mailingAddresses/${mailingAddress.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    ...validatedInputs,
                    countryCode: mailingAddressInputs.Country?.countryCode,
                    stateCode: mailingAddressInputs.State?.stateCode,
                }),
            });
            const data = await response.json();
            if (data.error) {
                throw new Error(data.error);
            }
            if (!data.mailingAddress) {
                throw new Error('Address not updated');
            }
            onUpdate();
        } catch (e) {
            sendMessage(e.message, 'danger');
        }
    }, [mailingAddress, onUpdate]);
    useEffect(() => {
        if (mailingAddress) {
            setInitialInputs({ ...mailingAddress,
                ...{
                    countryCode: mailingAddress.Country?.countryCode,
                    stateCode: mailingAddress.State?.stateCode,
                }});
        } else {
            setInitialInputs({});
        }
    }, [mailingAddress]);

    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        editMailingAddress();
    });

    return (<ModalComponentNoButton
        modalTitle={'Edit Mailing Address'}
        handleSave={editMailingAddress}
        show={show}
        setShow={setShow}
    >
        <Form
            onSubmit={handleSubmit}>
            <AddressInputs
                initialValues={initialInputs}
                setAddressInputs={setMailingAddressInputs} />
        </Form>
    </ModalComponentNoButton>);
}

AccountEditAddressModal.propTypes = {
    show: bool,
    setShow: func,
    mailingAddress: object,
    onUpdate: func,
};

AccountEditAddressModal.defaultProps = {
    show: false,
};